"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importStar(require("react"));
const use_form_api_1 = __importDefault(require("@data-driven-forms/react-form-renderer/use-form-api"));
const uuid_1 = require("uuid");
const Box_1 = __importDefault(require("../../../../../../layouts/Box"));
const Button_1 = __importDefault(require("../../../../../Button"));
const ColumnLayout_1 = __importStar(require("../../../../../../layouts/ColumnLayout"));
const layouts_1 = require("../../../../../../layouts");
const FieldArrayItem = ({ fields = [], fieldIndex, name, onRemove, removeLabel, showError, isReadOnly, layout, }) => {
    const formOptions = use_form_api_1.default();
    const editedFields = react_1.useMemo(() => {
        return fields.map((field) => {
            const computedName = field.name ? `${name}.${field.name}` : uuid_1.v4();
            return Object.assign(Object.assign({}, field), { showError, name: computedName, key: computedName, stretch: true, label: fieldIndex === 0 ? field.label : null });
        });
    }, [fields, name, fieldIndex, showError]);
    const getBox = (field) => (react_1.default.createElement(Box_1.default, { width: "100%", pr: 1 }, formOptions.renderForm([field])));
    return (react_1.default.createElement(Box_1.default, { display: "flex" },
        react_1.default.createElement(Box_1.default, { flexGrow: 1 }, layout === 'grid' ? (react_1.default.createElement(layouts_1.Grid, { container: true }, editedFields.map((field) => (react_1.default.createElement(layouts_1.Grid, { item: true, key: field.key, xs: 3 }, getBox(field)))))) : (react_1.default.createElement(ColumnLayout_1.default, { renderDivider: false }, editedFields.map((field) => (react_1.default.createElement(ColumnLayout_1.Column, { key: field.key }, getBox(field))))))),
        !isReadOnly && (react_1.default.createElement(Box_1.default, { display: "flex", alignItems: "flex-start", pt: fieldIndex === 0 ? 2.5 : 0.5 },
            react_1.default.createElement(Button_1.default, { onClick: () => {
                    onRemove(fieldIndex);
                } }, removeLabel)))));
};
exports.default = FieldArrayItem;
//# sourceMappingURL=index.js.map